export const routes = {
  HOME: '/',
  LOGIN: '/login',
  WALLET: '/wallet',
  PROFILE: '/profile',
}
